export const NAV_THEMES = {
    primary: {
        iconClass: 'ecx-nav-icon--primary',
        activeClass: 'ecx-nav-active ecx-nav-active--primary',
        idleClass: 'ecx-nav-idle ecx-nav-idle--primary',
    },
    purple: {
        iconClass: 'ecx-nav-icon--purple',
        activeClass: 'ecx-nav-active ecx-nav-active--purple',
        idleClass: 'ecx-nav-idle ecx-nav-idle--purple',
    },
    cyan: {
        iconClass: 'ecx-nav-icon--cyan',
        activeClass: 'ecx-nav-active ecx-nav-active--cyan',
        idleClass: 'ecx-nav-idle ecx-nav-idle--cyan',
    },
    indigo: {
        iconClass: 'ecx-nav-icon--indigo',
        activeClass: 'ecx-nav-active ecx-nav-active--indigo',
        idleClass: 'ecx-nav-idle ecx-nav-idle--indigo',
    },
    success: {
        iconClass: 'ecx-nav-icon--success',
        activeClass: 'ecx-nav-active ecx-nav-active--success',
        idleClass: 'ecx-nav-idle ecx-nav-idle--success',
    },
    teal: {
        iconClass: 'ecx-nav-icon--teal',
        activeClass: 'ecx-nav-active ecx-nav-active--teal',
        idleClass: 'ecx-nav-idle ecx-nav-idle--teal',
    },
    orange: {
        iconClass: 'ecx-nav-icon--orange',
        activeClass: 'ecx-nav-active ecx-nav-active--orange',
        idleClass: 'ecx-nav-idle ecx-nav-idle--orange',
    },
    pink: {
        iconClass: 'ecx-nav-icon--pink',
        activeClass: 'ecx-nav-active ecx-nav-active--pink',
        idleClass: 'ecx-nav-idle ecx-nav-idle--pink',
    },
    danger: {
        iconClass: 'ecx-nav-icon--danger',
        activeClass: 'ecx-nav-active ecx-nav-active--danger',
        idleClass: 'ecx-nav-idle ecx-nav-idle--danger',
    },
    warning: {
        iconClass: 'ecx-nav-icon--warning',
        activeClass: 'ecx-nav-active ecx-nav-active--warning',
        idleClass: 'ecx-nav-idle ecx-nav-idle--warning',
    },
    slate: {
        iconClass: 'ecx-nav-icon--slate',
        activeClass: 'ecx-nav-active ecx-nav-active--slate',
        idleClass: 'ecx-nav-idle ecx-nav-idle--slate',
    },
    violet: {
        iconClass: 'ecx-nav-icon--violet',
        activeClass: 'ecx-nav-active ecx-nav-active--violet',
        idleClass: 'ecx-nav-idle ecx-nav-idle--violet',
    },
    info: {
        iconClass: 'ecx-nav-icon--info',
        activeClass: 'ecx-nav-active ecx-nav-active--info',
        idleClass: 'ecx-nav-idle ecx-nav-idle--info',
    },
};

export const sidebarItems = [
    {
        label: 'Dashboard',
        icon: 'bi-speedometer2',
        to: '/dashboard',
        theme: 'primary',
    },
    {
        label: 'Appointments',
        icon: 'bi-calendar-event',
        to: '/appointments',
        theme: 'purple',
        featureKey: 'isAppointments',
    },
    {
        label: 'Web Bookings',
        icon: 'bi-calendar-check',
        to: '/web-bookings',
        theme: 'cyan',
        featureKey: 'booking',
        badgeKey: 'newWebBookingsCount',
    },
    {
        label: 'Patient Files',
        icon: 'bi-folder2-open',
        to: '/patient-files',
        theme: 'indigo',
    },
    {
        label: 'Optical Dispensary',
        icon: 'bi-eyeglasses',
        submenuKey: 'optical-dispensary',
        theme: 'violet',
        featureKey: 'isOpticalDispensary',
        submenu: [
            {
                label: 'Pickups',
                icon: 'bi-box-seam',
                to: '/optical-dispensary/pickups',
                featureKey: 'isOpticalDispensary',
            },
            {
                label: 'CL Orders',
                icon: 'bi-eye',
                to: '/optical-dispensary/cl-orders',
                featureKey: 'isOpticalDispensary',
            },
        ],
    },
    { type: 'divider', label: 'Communication Tools', accent: 'communication' },
    {
        label: 'Messages',
        icon: 'bi-chat-left-text',
        to: '/messages',
        theme: 'success',
        badgeKey: 'smsInbox',
        featureKey: 'twoWayText',
    },
    {
        label: 'Surveys',
        icon: 'bi-clipboard-check',
        to: '/surveys',
        theme: 'teal',
        featureKey: 'survey',
    },
    {
        label: 'Articles',
        icon: 'bi-file-text',
        to: '/articles',
        theme: 'orange',
        featureKey: 'isArticle',
    },
    {
        label: 'Newsletter',
        icon: 'bi-envelope',
        submenuKey: 'newsletter',
        theme: 'pink',
        submenu: [
            { label: 'Email Newsletter', icon: 'bi-envelope-paper', to: '/newsletter/email-newsletter', featureKey: 'newsletterEmail' },
            { label: 'SMS Newsletter', icon: 'bi-chat-text', to: '/newsletter/sms-newsletter', featureKey: 'newsletterSms' },
        ],
    },
    {
        label: 'Blast',
        icon: 'bi-megaphone',
        submenuKey: 'blast',
        theme: 'danger',
        submenu: [
            { label: 'Email Blast', icon: 'bi-send', to: '/blast/email', featureKey: 'blastEmail' },
            { label: 'SMS Blast', icon: 'bi-chat-dots', to: '/blast/sms', featureKey: 'blastSms' },
            { label: 'Call Blast', icon: 'bi-telephone-outbound', to: '/blast/call', featureKey: 'blastCall' },
        ],
    },
    {
        label: 'Reputation',
        icon: 'bi-star',
        to: '/reputation',
        theme: 'warning',
        featureKey: 'reputation',
    },
    {
        label: 'Recalls',
        icon: 'bi-person-check',
        to: '/recalls',
        theme: 'orange',
        featureKey: 'recall',
    },
    { type: 'divider', label: 'Misc', accent: 'misc' },
    {
        label: 'My Files',
        icon: 'bi-folder',
        to: '/my-files',
        theme: 'slate',
    },
    {
        label: 'Reports',
        icon: 'bi-file-earmark-bar-graph',
        to: '/reports',
        theme: 'teal',
    },
    {
        label: 'Activity',
        icon: 'bi-clock-history',
        to: '/activity',
        theme: 'violet',
    },
    {
        label: 'Settings',
        icon: 'bi-gear',
        submenuKey: 'settings',
        theme: 'info',
        submenu: [
            { label: 'Clinic', icon: 'bi-building', to: '/settings/clinic' },
            { label: 'Reminders', icon: 'bi-bell', to: '/settings/reminders' },
            { label: 'Users', icon: 'bi-people', to: '/settings/users' },
            { label: 'Eyeconx Features', icon: 'bi-stars', to: '/settings/features' },
            { label: 'Templates', icon: 'bi-layout-text-window', to: '/settings/templates' },
        ],
    },
];

const ROUTE_THEME_OVERRIDES = [
    { path: '/help', theme: 'primary' },
    { path: '/patient-engagement', theme: 'teal' },
    { path: '/cancellation-followups', theme: 'purple' },
    { path: '/invalid-details', theme: 'indigo' },
    { path: '/optical-dispensary', theme: 'violet' },
    { path: '/update-password', theme: 'info' },
    { path: '/newsletter', theme: 'pink' },
    { path: '/blast', theme: 'danger' },
    { path: '/settings', theme: 'info' },
    { path: '/surveys', theme: 'teal' },
];

export const getNavTheme = (themeKey) => NAV_THEMES[themeKey] || NAV_THEMES.primary;

export const getNavIconClass = (themeKey) => getNavTheme(themeKey).iconClass;

const collectRouteThemes = (items) => {
    const routes = [];

    items.forEach((item) => {
        if (item.to) {
            routes.push({ path: item.to, theme: item.theme });
        }

        if (item.submenu) {
            item.submenu.forEach((sub) => {
                routes.push({ path: sub.to, theme: item.theme });
            });
        }
    });

    return routes;
};

export const resolveNavThemeForPath = (pathname, items = sidebarItems) => {
    const normalizedPath = (pathname || '/').replace(/\/$/, '') || '/';
    const routes = [...collectRouteThemes(items), ...ROUTE_THEME_OVERRIDES].sort(
        (a, b) => b.path.length - a.path.length
    );

    const match = routes.find(
        (route) => normalizedPath === route.path || normalizedPath.startsWith(`${route.path}/`)
    );

    return match?.theme || 'primary';
};
